import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import InternalArticlesAPI from '../../api/internalArticles';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getInternalArticles(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getInternalArticleById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getInternalArticles({ commit }) {
    commit(types.SET_INTERNAL_ARTICLE_UI_FLAG, { isFetching: true });
    try {
      const response = await InternalArticlesAPI.get();
      commit(types.SET_INTERNAL_ARTICLES, response.data.payload);
    } finally {
      commit(types.SET_INTERNAL_ARTICLE_UI_FLAG, { isFetching: false });
    }
  },

  show: async function showInternalArticle({ commit }, id) {
    commit(types.SET_INTERNAL_ARTICLE_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await InternalArticlesAPI.show(id);
      commit(types.ADD_INTERNAL_ARTICLE, response.data);
    } finally {
      commit(types.SET_INTERNAL_ARTICLE_UI_FLAG, { isFetchingItem: false });
    }
  },

  create: async function createInternalArticle({ commit }, articleObj) {
    commit(types.SET_INTERNAL_ARTICLE_UI_FLAG, { isCreating: true });
    try {
      const response = await InternalArticlesAPI.create({
        internal_article: articleObj,
      });
      commit(types.ADD_INTERNAL_ARTICLE, response.data);
      return response.data;
    } finally {
      commit(types.SET_INTERNAL_ARTICLE_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateInternalArticle(
    { commit },
    { id, ...articleObj }
  ) {
    commit(types.SET_INTERNAL_ARTICLE_UI_FLAG, { isUpdating: true });
    try {
      const response = await InternalArticlesAPI.update(id, {
        internal_article: articleObj,
      });
      commit(types.EDIT_INTERNAL_ARTICLE, response.data);
      return response.data;
    } finally {
      commit(types.SET_INTERNAL_ARTICLE_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteInternalArticle({ commit }, id) {
    commit(types.SET_INTERNAL_ARTICLE_UI_FLAG, { isDeleting: true });
    try {
      await InternalArticlesAPI.delete(id);
      commit(types.DELETE_INTERNAL_ARTICLE, id);
    } finally {
      commit(types.SET_INTERNAL_ARTICLE_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_INTERNAL_ARTICLE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_INTERNAL_ARTICLES]: MutationHelpers.set,
  [types.ADD_INTERNAL_ARTICLE]: MutationHelpers.setSingleRecord,
  [types.EDIT_INTERNAL_ARTICLE]: MutationHelpers.update,
  [types.DELETE_INTERNAL_ARTICLE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
